import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

import { useIntl } from 'react-intl';
import classNames from 'classnames';

// components
import LanguageSwitch from '@/components/common/LanguageSwitch';

export default function Footer() {
  const i18n = useIntl();
  const router = useRouter();
  const { locale } = router;
  const isFr = locale === 'fr';
  const [footerCollapse, setFooterCollapse] = useState(false);

  return (
    <div className="footer">
      <div className="container">
        <a href="/" target="_self">
          <img
            className="logo mb-4"
            loading="lazy"
            alt="Logo Finary"
            src="/img/logo-dark.svg"
            width={85}
            height={23}
          />
        </a>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
          <div id="us" className="md:col-span-4">
            <p className="font-bold text-40 text-grey-700 leading-none">
              {i18n.formatMessage({ id: 'footer.platform' })}
            </p>
            <p className="text-16 text-grey-400 mt-4">
              {i18n.formatMessage({ id: 'footer.follow_portfolio' })}
            </p>
            <ul className="flex items-center">
              <li className="mr-2">
                <a
                  href="https://www.linkedin.com/company/finaryhq/"
                  target="_blank"
                  rel="nofollow noopener">
                  <img
                    width="22"
                    height="22"
                    src="/img/socials/linkedin.svg"
                    alt="Linkedin Finary"
                  />
                </a>
              </li>
              <li className="mr-2">
                <a
                  href="https://www.facebook.com/Finary-104848758108887"
                  target="_blank"
                  rel="nofollow noopener">
                  <img
                    width="24"
                    height="24"
                    src="/img/socials/facebook.svg"
                    alt="Facebook Finary"
                  />
                </a>
              </li>
              <li className="mr-2">
                <a href="https://twitter.com/finaryhq" target="_blank" rel="nofollow noopener">
                  <img width="20" height="24" src="/img/socials/twitter.svg" alt="Twitter Finary" />
                </a>
              </li>
              <li className="mr-2">
                <a
                  href="https://www.youtube.com/channel/UCRCCAnVyzDTcqNYh0pDcq7Q"
                  target="_blank"
                  rel="nofollow noopener">
                  <img width="30" height="30" src="/img/socials/youtube.svg" alt="Youtube Finary" />
                </a>
              </li>
            </ul>
            <LanguageSwitch />
          </div>
          {/* US */}
          <div className="md:col-span-3">
            <p className="title">{i18n.formatMessage({ id: 'footer.us' })}</p>
            <ul>
              <li>
                <Link href="/about-us">
                  <a>{i18n.formatMessage({ id: 'footer.us' })}</a>
                </Link>
              </li>
              <li>
                <Link href="/finary-plus">
                  <a>Finary plus</a>
                </Link>
              </li>
              <li>
                <a
                  href={
                    locale === 'fr'
                      ? `https://www.notion.so/finarywealth/Finary-Roadmap-d7b515028f254e21bc198a9d9d819821`
                      : `https://www.notion.so/finarywealth/Finary-Public-Roadmap-bab44d9f05164470a2e9f7962f5d08ed`
                  }
                  target="_blank"
                  rel="nofollow noopener">
                  Roadmap
                </a>
              </li>
              <li>
                <Link href={'/blog'} target="_blank">
                  Blog
                </Link>
              </li>
              <li>
                <a href="https://jobs.ashbyhq.com/finary" target="_blank">
                  Jobs
                </a>
              </li>
              {isFr && (
                <li>
                  <a href="https://community.finary.com/" target="_blank" rel="noopener">
                    {i18n.formatMessage({ id: 'footer.community' })}
                  </a>
                </li>
              )}
              <li>
                <a
                  href={`https://www.notion.so/finarywealth/propos-de-Finary-30b820be6803404b8b38c38d6630ba61`}
                  target="_blank">
                  {i18n.formatMessage({ id: 'header.press' })}
                </a>
              </li>
            </ul>
          </div>
          {/* Invest */}
          {isFr && (
            <div className="md:col-span-3">
              <p className="title">{i18n.formatMessage({ id: 'footer.invest' })}</p>
              <ul>
                <li>
                  <a href="https://app.livestorm.co/finary" target="_blank">
                    Finary Talk
                  </a>
                </li>
                <li
                  className="cursor-pointer"
                  role="tab"
                  aria-expanded={footerCollapse && footerCollapse == 1}>
                  <span onClick={() => setFooterCollapse(!footerCollapse ? 1 : false)}>
                    Gestion de patrimoine
                    <img
                      width={15}
                      height={10}
                      className={classNames({
                        'transition transform rotate-180': footerCollapse && footerCollapse == 1,
                        'ml-2 inline-block ': true,
                      })}
                      src="/img/chevron-down.svg"
                      alt="icon chevron down"
                    />
                  </span>
                  {footerCollapse && footerCollapse == 1 && (
                    <ul role="tabpanel">
                      <li>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_FINANCES_URL}/gestion-de-patrimoine/`}>
                          <a>Gestion de patrimoine</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/gestion-de-patrimoine/conseiller-en-gestion-de-patrimoine">
                          <a>conseiller en patrimoine</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/gestion-de-patrimoine/logiciel-gestion-patrimoine">
                          <a>Logiciel gestion de patrimoine</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/gestion-de-patrimoine/apport-cession">
                          <a>Apport Cession</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/gestion-de-patrimoine/conseil-en-investissement-financier">
                          <a>Conseil en investissement financier</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/gestion-de-patrimoine/patrimoine-moyen-des-francais">
                          <a>L'étude Finary sur le patrimoine moyen des Français</a>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className="cursor-pointer"
                  role="tab"
                  aria-expanded={footerCollapse && footerCollapse == 2}>
                  <span onClick={() => setFooterCollapse(!footerCollapse ? 2 : false)}>
                    Investir en bourse
                    <img
                      width={15}
                      height={10}
                      className={classNames({
                        'transition transform rotate-180': footerCollapse && footerCollapse == 2,
                        'ml-2 inline-block ': true,
                      })}
                      src="/img/chevron-down.svg"
                      alt="icon chevron down"
                    />
                  </span>
                  {footerCollapse && footerCollapse == 2 && (
                    <ul role="tabpanel">
                      <li>
                        <a href={`${process.env.NEXT_PUBLIC_FINANCES_URL}/investir-en-bourse/`}>
                          Investir en bourse
                        </a>
                      </li>
                      <li>
                        <a
                          href={`${process.env.NEXT_PUBLIC_FINANCES_URL}/investir-en-bourse/comment-acheter-des-actions/`}>
                          Acheter des actions
                        </a>
                      </li>
                      <li>
                        <a
                          href={`${process.env.NEXT_PUBLIC_FINANCES_URL}/investir-en-bourse/etf/quest-ce-quun-etf/`}>
                          ETF
                        </a>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className="cursor-pointer"
                  role="tab"
                  aria-expanded={footerCollapse && footerCollapse == 3}>
                  <span onClick={() => setFooterCollapse(!footerCollapse ? 3 : false)}>
                    Comment investir
                    <img
                      width={15}
                      height={10}
                      className={classNames({
                        'transition transform rotate-180': footerCollapse && footerCollapse == 3,
                        'ml-2 inline-block ': true,
                      })}
                      src="/img/chevron-down.svg"
                      alt="icon chevron down"
                    />
                  </span>
                  {footerCollapse && footerCollapse == 3 && (
                    <ul role="tabpanel">
                      <li>
                        <a href={`${process.env.NEXT_PUBLIC_FINANCES_URL}/ou-placer-son-argent/`}>
                          Comment investir
                        </a>
                      </li>
                      <li>
                        <Link href="/comment-investir/investir-20-000-euros">
                          <a>Ou investir 20 000 euros ?</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/investir-30-000-euros">
                          <a>Où investir 30 000 euros ?</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/investir-50000-euros">
                          <a>Investir 50 000 euros</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/placer-300-000-euros">
                          <a>Placer 300 000 euros</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/placer-400-000-euros">
                          <a>Placer 400 000 euros</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/placer-500-000-euros">
                          <a>Placer 500 000 euros</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/investir-son-argent-6-erreurs-a-eviter">
                          <a>Investir son argent : les 6 erreurs à éviter</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/epargne-de-precaution">
                          <a>Épargne de précaution : pourquoi est-ce indispensable ?</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/gestion-pilotee">
                          <a>Faut-il choisir la gestion pilotée ?</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/comment-investir/fcpr">
                          <a>FPCR : Investir dans des entreprises non cotées</a>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <Link href="/excel-patrimoine">{i18n.formatMessage({ id: 'footer.excel' })}</Link>
                </li>
                <li>
                  <Link href="/tableau-excel-budget">
                    {i18n.formatMessage({ id: 'footer.table_excel' })}
                  </Link>
                </li>
                <li>
                  <Link href="/agregateur-de-compte">Agrégateur de compte</Link>
                </li>
                <li
                  className="cursor-pointer"
                  role="tab"
                  aria-expanded={footerCollapse && footerCollapse == 4}>
                  <span onClick={() => setFooterCollapse(!footerCollapse ? 4 : false)}>
                    PEA
                    <img
                      width={15}
                      height={10}
                      className={classNames({
                        'transition transform rotate-180': footerCollapse && footerCollapse == 4,
                        'ml-2 inline-block ': true,
                      })}
                      src="/img/chevron-down.svg"
                      alt="icon chevron down"
                    />
                  </span>
                  {footerCollapse && footerCollapse == 4 && (
                    <ul role="tabpanel">
                      <li>
                        <a
                          href={`${process.env.NEXT_PUBLIC_FINANCES_URL}/investir-en-bourse/pea-plan-epargne-actions-pea/`}>
                          PEA
                        </a>
                      </li>
                      <li>
                        <a
                          href={`${process.env.NEXT_PUBLIC_FINANCES_URL}/investir-en-bourse/pea-plan-epargne-actions-pea/peut-on-avoir-plusieurs-pea/`}>
                          Peut-on avoir plusieurs PEA ?
                        </a>
                      </li>
                      <li>
                        <Link href="/pea/quelle-fiscalite-pour-le-pea">
                          <a>Quelle fiscalité pour le PEA ?</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/pea/quels-atouts-pea-assurance">
                          <a>Quels sont les atouts du PEA assurance</a>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  className="cursor-pointer"
                  role="tab"
                  aria-expanded={footerCollapse && footerCollapse == 5}>
                  <span onClick={() => setFooterCollapse(!footerCollapse ? 5 : false)}>
                    Investir crypto monnaie
                    <img
                      width={15}
                      height={10}
                      className={classNames({
                        'transition transform rotate-180': footerCollapse && footerCollapse == 5,
                        'ml-2 inline-block ': true,
                      })}
                      src="/img/chevron-down.svg"
                      alt="icon chevron down"
                    />
                  </span>
                  {footerCollapse && footerCollapse == 5 && (
                    <ul role="tabpanel">
                      <li>
                        <Link href="/fr/crypto-prix">
                          <a>Investir crypto monnaie</a>
                        </Link>
                      </li>
                      <li>
                        <Link href="/fr/crypto-prix/bitcoin">
                          <a>Bitcoin</a>
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
              </ul>
            </div>
          )}
          {/* Links */}
          <div className="md:col-span-2">
            <p className="title">{i18n.formatMessage({ id: 'footer.links' })}</p>
            <ul>
              <li>
                <a href="mailto:hello@finary.com" target="_blank" rel="nofollow">
                  {i18n.formatMessage({ id: 'footer.contact' })}
                </a>
              </li>
              <li>
                <a href="https://help.finary.com/" target="_blank" rel="noopener">
                  {i18n.formatMessage({ id: 'footer.help' })}
                </a>
              </li>
              <li>
                <Link href="/legal">
                  <a>{i18n.formatMessage({ id: 'footer.mentions' })}</a>
                </Link>
              </li>
              <li>
                <Link href="/terms">
                  <a>{i18n.formatMessage({ id: 'footer.legal' })}</a>
                </Link>
              </li>
              <li>
                <Link href="/privacy">
                  <a>{i18n.formatMessage({ id: 'footer.privacy' })}</a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
